(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 820px)');
  const DESKTOP_MQ = window.matchMedia('(min-width: 821px)');
  const ACTIVATE_KEYS = new Set(['Enter', ' ']);
  const swipers = new WeakMap();

  function isInteractiveTarget(target) {
    return Boolean(
      target.closest(
        'a, button, input, select, textarea, btn-show-quickview, [data-minions-products-ignore-toggle], .swiper-pagination, [data-minions-products-scroll]'
      )
    );
  }

  function getCards(root) {
    return Array.from(root.querySelectorAll('[data-minions-products-card]'));
  }

  function sortCardsIntoMerged(merged, root) {
    const soon = root.querySelector('[data-minions-products-soon]');
    const cards = getCards(root);
    cards.sort(
      (a, b) =>
        Number(a.getAttribute('data-minions-products-card-index')) -
        Number(b.getAttribute('data-minions-products-card-index'))
    );
    cards.forEach((card) => {
      merged.appendChild(card);
    });
    if (soon) merged.appendChild(soon);
  }

  function destroySwiperInstance(root) {
    const inst = swipers.get(root);
    if (inst) {
      inst.destroy(false, true);
      swipers.delete(root);
    }
  }

  function getDesktopScroll(root) {
    return root.querySelector('[data-minions-products-desktop-scroll]');
  }

  function getScrollHost(root) {
    const scroller = getDesktopScroll(root);
    if (!scroller) return null;
    return scroller;
  }

  function getScrollMetrics(host) {
    if (!host) {
      return { scrollLeft: 0, maxScroll: 0 };
    }
    return {
      scrollLeft: host.scrollLeft,
      maxScroll: Math.max(0, host.scrollWidth - host.clientWidth),
    };
  }

  function setScrollControlHidden(control, hide) {
    if (!control) return;
    if (hide) {
      control.setAttribute('hidden', '');
    } else {
      control.removeAttribute('hidden');
    }
  }

  function updateDesktopScrollNav(root) {
    const wrap = root.querySelector('[data-minions-products-desktop-scroll-wrap]');
    const host = getScrollHost(root);
    const prev = root.querySelector('[data-minions-products-scroll="prev"]');
    const next = root.querySelector('[data-minions-products-scroll="next"]');
    if (!host || !prev || !next) return;

    const overflowLayout = root.classList.contains('minions-products--desktop-overflow');

    if (!DESKTOP_MQ.matches || !overflowLayout) {
      setScrollControlHidden(prev, true);
      setScrollControlHidden(next, true);
      wrap?.classList.remove('minions-products__desktop-scroll-wrap--active');
      root.classList.remove('minions-products--has-desktop-scroll');
      prev.classList.remove('is-at-end');
      next.classList.remove('is-at-end');
      prev.removeAttribute('aria-disabled');
      next.removeAttribute('aria-disabled');
      return;
    }

    const { scrollLeft, maxScroll } = getScrollMetrics(host);
    const canScroll = maxScroll > 1;

    setScrollControlHidden(prev, false);
    setScrollControlHidden(next, false);
    wrap?.classList.toggle('minions-products__desktop-scroll-wrap--active', canScroll);
    root.classList.toggle('minions-products--has-desktop-scroll', canScroll);

    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft >= maxScroll - 1;

    prev.classList.toggle('is-at-end', canScroll && atStart);
    next.classList.toggle('is-at-end', canScroll && atEnd);
    prev.setAttribute('aria-disabled', canScroll && atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', canScroll && atEnd ? 'true' : 'false');
  }

  function scrollDesktop(root, direction) {
    const host = getScrollHost(root);
    if (!host) return;

    const { maxScroll } = getScrollMetrics(host);
    if (maxScroll <= 1) return;

    const items = [
      ...root.querySelectorAll('[data-minions-products-card], [data-minions-products-soon]'),
    ];
    const currentLeft = host.scrollLeft;

    if (items.length) {
      const itemOffsets = items.map(
        (item) => item.getBoundingClientRect().left - host.getBoundingClientRect().left + currentLeft
      );
      let targetLeft = null;

      if (direction > 0) {
        for (const itemLeft of itemOffsets) {
          if (itemLeft > currentLeft + 4) {
            targetLeft = itemLeft;
            break;
          }
        }
        if (targetLeft == null) targetLeft = maxScroll;
      } else {
        for (let i = itemOffsets.length - 1; i >= 0; i -= 1) {
          const itemLeft = itemOffsets[i];
          if (itemLeft < currentLeft - 4) {
            targetLeft = itemLeft;
            break;
          }
        }
        if (targetLeft == null) targetLeft = 0;
      }

      host.scrollTo({ left: Math.max(0, Math.min(targetLeft, maxScroll)), behavior: 'smooth' });
      return;
    }

    const step = Math.max(host.clientWidth * 0.75, 280);
    host.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function bindDesktopScrollNav(root) {
    if (root.dataset.minionsProductsScrollNavBound === 'true') return;
    root.dataset.minionsProductsScrollNavBound = 'true';

    const host = getScrollHost(root);
    const prev = root.querySelector('[data-minions-products-scroll="prev"]');
    const next = root.querySelector('[data-minions-products-scroll="next"]');

    const onScroll = () => updateDesktopScrollNav(root);

    if (host) {
      host.addEventListener('scroll', onScroll, { passive: true });
    }

    [prev, next].forEach((btn) => {
      if (!btn) return;
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (btn.getAttribute('aria-disabled') === 'true') return;
        const direction = btn.getAttribute('data-minions-products-scroll') === 'next' ? 1 : -1;
        scrollDesktop(root, direction);
      });
    });

    if (typeof ResizeObserver !== 'undefined' && host) {
      const merged = root.querySelector('[data-minions-products-merged]');
      const ro = new ResizeObserver(() => updateDesktopScrollNav(root));
      ro.observe(host);
      if (merged) ro.observe(merged);
    }

    root.querySelectorAll('.minions-products__combo-card img, .minions-products__soon-image').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => updateDesktopScrollNav(root), { once: true });
    });
  }

  function restoreSoon(root) {
    const soon = root.querySelector('[data-minions-products-soon]');
    const merged = root.querySelector('[data-minions-products-merged]');
    if (!soon || !merged) return;
    merged.appendChild(soon);
  }

  function extractCarouselNodes(root, merged) {
    const bottom = root.querySelector('[data-minions-products-bottom]');
    if (!bottom) return;
    const wrapper = bottom.querySelector('[data-minions-products-carousel-wrapper]');
    if (!wrapper) return;
    const slides = [...wrapper.querySelectorAll('.swiper-slide')];
    slides.forEach((slide) => {
      [...slide.children].forEach((node) => {
        if (!node.matches) return;
        if (node.matches('[data-minions-products-card]')) merged.appendChild(node);
        if (node.matches('[data-minions-products-soon], .minions-products__soon-card')) restoreSoon(root);
      });
      slide.remove();
    });
  }

  function updateMergedSecondaryClass(root, merged) {
    const cards = getCards(root);
    const active = root.querySelector('[data-minions-products-card].active');
    if (!merged || cards.length < 2 || !active) {
      merged?.classList.remove('minions-products__merged--secondary-active');
      return;
    }
    const activeIndex = Number(active.getAttribute('data-minions-products-card-index'));
    const useSecondaryLayout = cards.length === 2 && activeIndex === 1;
    merged.classList.toggle('minions-products__merged--secondary-active', useSecondaryLayout);
  }

  function initSwiper(root, bottom) {
    const swiperEl = bottom.querySelector('.swiper');
    const paginationEl = bottom.querySelector('.minions-products__swiper-pagination');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const space = 12;

    const inst = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: space,
      watchOverflow: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
    swipers.set(root, inst);
  }

  function syncLayout(root) {
    const layout = root.querySelector('.minions-products__layout');
    const merged = root.querySelector('[data-minions-products-merged]');
    const bottom = root.querySelector('[data-minions-products-bottom]');
    const soon = root.querySelector('[data-minions-products-soon]');
    if (!layout || !merged) return;

    const cards = getCards(root);
    const useCarousel = MOBILE_MQ.matches && bottom && cards.length >= 2;

    destroySwiperInstance(root);
    extractCarouselNodes(root, merged);
    sortCardsIntoMerged(merged, root);

    if (!useCarousel) {
      if (bottom) {
        bottom.hidden = true;
        bottom.classList.remove('is-visible');
        bottom.setAttribute('aria-hidden', 'true');
        const wrapper = bottom.querySelector('[data-minions-products-carousel-wrapper]');
        if (wrapper) wrapper.innerHTML = '';
      }
      restoreSoon(root);
      updateMergedSecondaryClass(root, merged);
      scheduleDesktopScrollNavUpdate(root);
      return;
    }

    const active = root.querySelector('[data-minions-products-card].active');
    const inactive = getCards(root).filter((c) => !c.classList.contains('active'));
    const wrapper = bottom.querySelector('[data-minions-products-carousel-wrapper]');
    if (!wrapper || !soon) {
      if (bottom) {
        bottom.hidden = true;
        bottom.classList.remove('is-visible');
        bottom.setAttribute('aria-hidden', 'true');
      }
      updateMergedSecondaryClass(root, merged);
      return;
    }

    wrapper.innerHTML = '';

    inactive.forEach((card) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide minions-products__carousel-slide';
      slide.appendChild(card);
      wrapper.appendChild(slide);
    });

    const soonSlide = document.createElement('div');
    soonSlide.className =
      'swiper-slide minions-products__carousel-slide minions-products__carousel-slide--soon';
    soonSlide.appendChild(soon);
    wrapper.appendChild(soonSlide);

    if (active) merged.appendChild(active);

    bottom.hidden = false;
    bottom.classList.add('is-visible');
    bottom.removeAttribute('aria-hidden');

    updateMergedSecondaryClass(root, merged);

    requestAnimationFrame(() => {
      initSwiper(root, bottom);
      updateDesktopScrollNav(root);
    });
  }

  function scheduleDesktopScrollNavUpdate(root) {
    requestAnimationFrame(() => {
      updateDesktopScrollNav(root);
      requestAnimationFrame(() => updateDesktopScrollNav(root));
    });
  }

  function setActiveCard(root, card) {
    const cards = root.querySelectorAll('[data-minions-products-card]');

    cards.forEach((item) => {
      const isActive = item === card;
      item.classList.toggle('active', isActive);
      if (item.hasAttribute('aria-pressed')) {
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
      item.querySelectorAll('[data-minions-products-features]').forEach((panel) => {
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      if(isActive) {
        setTimeout(()=>{
          console.log("minions-products__features", item.querySelector(".minions-products__features"))
          item.querySelector(".minions-products__features").scrollIntoView({behavior: "smooth", block: "center"});

        }, 100)
      }
    });

    syncLayout(root);
  }

  function bindToggle(root) {
    if (root.getAttribute('data-minions-products-toggle') !== 'true') return;
    if (root.dataset.minionsProductsToggleBound === 'true') return;
    root.dataset.minionsProductsToggleBound = 'true';

    root.addEventListener('click', (event) => {
      if (isInteractiveTarget(event.target)) return;
      const card = event.target.closest('[data-minions-products-card]');
      if (!card || !root.contains(card)) return;
      if (card.classList.contains('active')) return;
      setActiveCard(root, card);
    });

    root.addEventListener('keydown', (event) => {
      if (!ACTIVATE_KEYS.has(event.key)) return;
      const card = event.target.closest('[data-minions-products-card]');
      if (!card || !root.contains(card)) return;
      if (isInteractiveTarget(event.target)) return;
      if (card.classList.contains('active')) return;
      event.preventDefault();
      setActiveCard(root, card);
    });
  }

  let resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      document.querySelectorAll('[data-minions-products-root]').forEach((root) => {
        syncLayout(root);
        scheduleDesktopScrollNavUpdate(root);
      });
    }, 120);
  }

  function init() {
    document.querySelectorAll('[data-minions-products-root]').forEach((root) => {
      syncLayout(root);
      bindToggle(root);
      bindDesktopScrollNav(root);
      scheduleDesktopScrollNavUpdate(root);
      window.setTimeout(() => updateDesktopScrollNav(root), 400);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', onResize);
  MOBILE_MQ.addEventListener('change', onResize);
  DESKTOP_MQ.addEventListener('change', onResize);

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!target || typeof target.matches !== 'function') return;
    const root = target.matches('[data-minions-products-root]')
      ? target
      : target.querySelector('[data-minions-products-root]');
    if (root) {
      syncLayout(root);
      bindToggle(root);
      bindDesktopScrollNav(root);
      scheduleDesktopScrollNavUpdate(root);
      window.setTimeout(() => updateDesktopScrollNav(root), 400);
    }
  });
})();
